var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-drawer',{attrs:{"title":_vm.title,"placement":"right","footer":false,"visible":_vm.visible,"width":"600px"},on:{"close":_vm.onClose}},[_c('a-form-model',{ref:"LectureCrewRef",attrs:{"model":_vm.form,"rules":_vm.rules}},[_c('a-form-model-item',{attrs:{"label":"邀请内容","prop":"InvitationContent"}},[_c('a-textarea',{attrs:{"placeholder":"请输入","auto-size":{ minRows: 10, maxRows: 15 }},model:{value:(_vm.form.InvitationContent),callback:function ($$v) {_vm.$set(_vm.form, "InvitationContent", $$v)},expression:"form.InvitationContent"}})],1)],1),_c('div',{style:({
          position: 'absolute',
          bottom: 0,
          width: '100%',
          borderTop: '1px solid #e8e8e8',
          padding: '10px 16px',
          textAlign: 'right',
          left: 0,
          background: '#fff',
          borderRadius: '0 0 4px 4px',
        })},[_c('a-button',{staticStyle:{"marginRight":"8px"},attrs:{"disabled":_vm.form.InvitationContent ? false:true},on:{"click":_vm.duplicateBtn}},[_vm._v(" 复制内容 ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }